module.exports = __webpack_public_path__ + "img/chander.03443a0e.png";